import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=700a1723&scoped=true&"
import script from "./Quote.vue?vue&type=script&lang=ts&"
export * from "./Quote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a1723",
  null
  
)

export default component.exports